module.exports = __webpack_public_path__ + "img/double_plug_the_same_side_box1.282cd10f.png";